import {Pipe, PipeTransform} from '@angular/core';
import {parsePhoneNumberWithError} from 'libphonenumber-js';

@Pipe({
    name: 'appPhoneNumberFormat',
    standalone: false
})
export class PhoneNumberFormatPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return value;
        }

        try {
            return parsePhoneNumberWithError(value, 'NL').formatInternational();
        } catch (error) {
            console.error(`Error parsing phone number: ${value}`);
            return value;
        }
    }
}
